export default __webpack_public_path__ + "static/media/playground2.115485ab.png";